const orderdata = {
  namespaced: true,
  state: {
    isStoredId: 1,
    isProductId: 2,
  },
  mutations: {
    // setNull(state, payload) {
    //   state.isStoredId = '';
    //   state.isProductId = '';
    // },
    setIdNum(state, payload) {
      state.isStoredId = payload.isStoredId;
      state.isProductId = payload.isProductId;
    },
  },
};
export default orderdata;
